import React from 'react';

const Home = () => {
  // Replace this with the actual path to your resume file
  const resumeFile = '/Resume_Aniket_Adarsh.pdf';

  return (
    <section id="home" className="min-h-screen flex items-center justify-center text-white px-6 relative overflow-hidden">
      {/* Background tech elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Large animated tech elements */}
        <div className="absolute top-1/4 left-[15%] w-24 h-24 border-4 border-blue-400/60 rounded-lg animate-float-1"></div>
        <div className="absolute bottom-1/3 right-[20%] w-20 h-20 border-3 border-blue-400/50 rounded-full animate-float-2"></div>
        <div className="absolute top-1/3 right-[30%] w-16 h-16 border-t-4 border-r-4 border-blue-400/50 transform animate-spin-slow"></div>
        <div className="absolute bottom-1/4 left-[30%] w-32 h-1.5 bg-blue-400/50 animate-wave"></div>

        {/* Additional floating elements */}
        <div className="absolute top-[40%] left-[10%] w-12 h-12 bg-blue-400/40 rounded-full animate-float-3"></div>
        <div className="absolute bottom-[35%] right-[10%] w-14 h-14 border-2 border-blue-400/50 transform rotate-45 animate-pulse"></div>
      </div>

      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto flex flex-col md:flex-row items-center z-10">
        {/* Image container - now larger */}
        <div className="md:w-1/2 flex justify-center relative mb-10 md:mb-0">
          {/* Extra large profile image */}
          <div className="md:w-1/2 flex justify-center items-center mb-10 md:mb-0">
            {/* Perfect circle container */}
            <div className="relative" style={{
              width: 'min(80vw, 500px)',
              height: 'min(80vw, 500px)',
              aspectRatio: '1/1'
            }}>
              {/* Profile image with perfect circle mask */}
              <div className="relative w-full h-full overflow-hidden rounded-full"
                style={{
                  border: '3px solid rgba(59, 130, 246, 0.8)',
                  transform: 'perspective(1000px) rotateY(5deg)',
                }}>
                <img
                  src="profile12.png"
                  alt="Aniket Adarsh"
                  className="w-full h-full object-cover"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectPosition: 'center',
                    filter: 'drop-shadow(0 15px 40px rgba(59, 130, 246, 0.4))'
                  }}
                />
              </div>
            </div>
          </div>
          {/* <img
            src="profile12.png"
            alt="Aniket Adarsh"
            className="rounded-xl shadow-2xl w-full max-w-2xl object-cover relative z-20"
            style={{
              border: 'none',
              transform: 'perspective(1000px) rotateY(5deg)',
              filter: 'drop-shadow(0 15px 40px rgba(59, 130, 246, 0.4))'
            }}
          /> */}
        </div>

        {/* Text content */}
        <div className="md:w-1/2 text-center md:text-left px-8">
          <h1 className="text-2xl md:text-4xl font-bold mb-3">
            Hi, I'm
          </h1>
          <h2 className="text-6xl md:text-7xl font-bold mb-8"><span className="text-blue-400">Aniket Adarsh</span></h2>
          <p className="text-1xl md:text-1xl mb-10 text-gray-300 leading-relaxed">
            An aspiring Data Scientist and Machine Learning enthusiast with a passion for solving real-world problems
          </p>

          {/* Social Media Icons - just icons without text or boxes */}
          <div className="flex flex-wrap justify-center md:justify-start gap-6 mb-10">
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/aniket-adarsh/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>

            {/* GitHub */}
            <a
              href="https://github.com/aniketofficial540"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors duration-300"
              aria-label="GitHub"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </svg>
            </a>

            {/* X (Twitter) */}
            <a
              href="https://x.com/_aniket_adarsh"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors duration-300"
              aria-label="X (Twitter)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="https://instagram.com/im_aniket_adarsh"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors duration-300"
              aria-label="Instagram"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.058 1.689-.072 4.948-.072zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>

          {/* Resume Download Button */}
          <a
            href={resumeFile}
            download="Resume_Aniket_Adarsh.pdf"
            className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white font-bold py-3 px-8 rounded-xl transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/40 hover:translate-y-[-3px] text-lg"
            target="_blank"  // Open in new tab for viewing
            rel="noopener noreferrer"  // Security best practice
          >
            Resume
          </a>
        </div>
      </div>

      {/* Custom animations */}
      <style jsx global>{`
        @keyframes float-1 {
          0%, 100% { transform: translateY(0) rotate(12deg) scale(1); }
          50% { transform: translateY(-25px) rotate(12deg) scale(1.05); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(20px) scale(1.1); }
        }
        @keyframes float-3 {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-15px) scale(1.15); }
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes wave {
          0%, 100% { transform: rotate(45deg) scaleX(1); }
          50% { transform: rotate(45deg) scaleX(1.5); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.5; transform: rotate(45deg) scale(1); }
          50% { opacity: 0.9; transform: rotate(45deg) scale(1.1); }
        }
        .animate-float-1 { animation: float-1 7s ease-in-out infinite; }
        .animate-float-2 { animation: float-2 6s ease-in-out infinite; }
        .animate-float-3 { animation: float-3 5s ease-in-out infinite; }
        .animate-spin-slow { animation: spin-slow 25s linear infinite; }
        .animate-wave { animation: wave 5s ease-in-out infinite; }
        .animate-pulse { animation: pulse 4s ease-in-out infinite; }
      `}</style>
    </section>
  );
};

export default Home;